/**
 * Configuration-Key im Fachverfahrens-Manifest für das Zeigen/Verstecken der Spalte Fachlicher Typ, sowie des dazugehörigen Dropdowns
 * im Upload-Modul (Dokumente anhängen im Antrag)
 */
export const FACHLICHER_TYP_IN_UPLOAD = "Upload_ZeigeFachlicherDokumententyp";

/**
 * Configuration-Key im Fachverfahrens-Manifest für das Zeigen/Verstecken des Textbausteine-Buttons beim Informationen Nachfordern
 */
export const TEXTBAUSTEINE_IN_NACHFORDERUNG = "InformationenNachfordern_ZeigeTextbausteine";

/**
 * Configuration-Key für die im Prozessschritt Wizard anzuzeigenden Prozessschritte.
 * Anzugeben als JSON der Form
 */
export const WIZARD_TASKS_FVMANIFEST_KEY = "WIZARD_TASKS";
